import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStaticFlags } from 'src/common/hooks/useStaticFlags/useStaticFlags';
import { StaticFlagProtectedRouteProps } from 'src/routes/FlagProtectedRoute/StaticFlagProtectedRoute/StaticFlagProtectedRoute.types';

const StaticFlagProtectedRoute: React.FC<StaticFlagProtectedRouteProps> = ({
  flag,
  expectedValue,
  redirectTo = '/',
  children,
}) => {
  const flags = useStaticFlags();
  const navigate = useNavigate();
  const [allowed, setAllowed] = useState<boolean>();

  useEffect(() => {
    const flagValue = flags[flag];
    if (expectedValue === 'on') {
      setAllowed(flagValue === true);
    } else if (expectedValue === 'off') {
      setAllowed(flagValue === false);
    } else {
      setAllowed(flagValue === expectedValue);
    }

    if (allowed === false) {
      navigate(redirectTo);
    }
  }, [flags, expectedValue, navigate, redirectTo, allowed]);

  return allowed ? children : null;
};

export default StaticFlagProtectedRoute;
